module.exports = __webpack_public_path__ + "static/media/18.edc9532c.JPG";